import { useState } from "react";
import styled from "styled-components";
import theme from "../../theme/theme";
import Tabs from "../Base/Tabs";
import StrategiesList from "./StrategiesList";
import StrategistsList from "./StrategistsList";
import Tooltip from "../Base/Tooltip";
import CustomExpandCollapseButton from "../CustomExpandCollapseButton";

const Wrapper = styled.div`
  min-width: 150px;

  h2 {
    display: flex;
    align-items: center;
    margin: 10px 0;
    text-align: left;
    font-weight: 500;
    color: ${theme.colors.primaryStrong};

    @media (max-width: 480px) {
      padding: 5% 5%;
      font-size: 20px;
    }
  }

  .arrowDown {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-20px, -50%) rotate(-90deg);
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    border-color: ${theme.colors.primaryStrong};
  }
`;

const StrategyPicker = ({ data }) => {
  const [isPanelExpanded, setIsPanelExpanded] = useState(false);
  if (!data) return null;

  const getStrategists = (strategies) => {
    let strategists = [];
    strategies.forEach((item) => {
      item.strategists?.forEach((el) => {
        const alreadyExists = strategists.some(
          (strategist) => strategist.id === el.id
        );
        if (!alreadyExists) {
          strategists.push({ ...el, strategy: item.name });
        }
      });
    });
    return strategists;
  };

  // const strategistsList = getStrategists(data);

  const strategistsList = [
    {
      name: "Capital Management Services",
      url: "https://serverless-cog-s3.s3.amazonaws.com/CMS_Logo-300x120%402x.png",
      biographyURL:
        "https://tactivewealth.com/financial-investment-strategies/#toggle-id-3",
      height: 100,
    },
    {
      name: "Market Gauge",
      url: "https://serverless-cog-s3.s3.amazonaws.com/MarketGauge_Logo-300x127%402x.png",
      biographyURL:
        "https://tactivewealth.com/financial-investment-strategies/#toggle-id-3",
      height: 80,
    },
    {
      name: "Sungarden Investments",
      url: "https://serverless-cog-s3.s3.amazonaws.com/Sungarden_Logo-300x150%402x.png",
      biographyURL:
        "https://tactivewealth.com/financial-investment-strategies/#toggle-id-3",
      height: 80,
    },
  ];

  return (
    <Wrapper>
      <h2 className="paddingInMobile">
        Your Strategy{" "}
        <Tooltip text="After completing your goal and risk tolerance questions, Tactive suggests a personalized investment strategy. This is typically a blend of strategies from vetted Strategists that use dynamic investment models (ie. counter to the “buy and hold” philosophy.) You can check out their profiles in the “Strategists” tab. You can always adjust your settings to change your blend." />
      </h2>
      {window.screen.width < 480 ? (
        <>
          {isPanelExpanded && <StrategiesList />}
          <CustomExpandCollapseButton
            toggleExpandCollapse={setIsPanelExpanded}
            isPanelExpanded={isPanelExpanded}
          />
        </>
      ) : (
        <StrategiesList />
      )}
    </Wrapper>
  );
};

export default StrategyPicker;
